import bluebird from 'bluebird';
import StatusCodes from 'http-status-codes';
import accountApiClient from 'api/accountApiClient';
import transform from './exposeTransformer';

export const actionTypes = {
  FETCH_REQUESTED: 'FETCH_REALTOR_REQUESTED',
  FETCH_SUCCEEDED: 'FETCH_REALTOR_SUCCEEDED',
  FETCH_FAILED: 'FETCH_REALTOR_FAILED',
};

// ------------------------------------
// Action creators
// ------------------------------------
export const fetchRealtorRequest = () => ({
  type: actionTypes.FETCH_REQUESTED,
});

export const fetchRealtorSuccess = (realtorData: any) => ({
  type: actionTypes.FETCH_SUCCEEDED,
  realtorData,
});

export const fetchRealtorFailure = (status: any) => ({
  type: actionTypes.FETCH_FAILED,
  httpStatus: status,
});

export const fetchRealtorData = (cwid: any, state: any) => (dispatch: any) =>
  bluebird
    .try(() => dispatch(fetchRealtorRequest()))
    .then(() => accountApiClient.fetchRealtorData(cwid))
    .tap((realtorData: any) => {
      const transformedRealtorData = transform(realtorData, state);
      return dispatch(fetchRealtorSuccess(transformedRealtorData));
    })
    .tapCatch((error: any) =>
      dispatch(fetchRealtorFailure(error.response.status)),
    );

const INITIAL_STATE = {};
export const reducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    case actionTypes.FETCH_REQUESTED:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_SUCCEEDED:
      return {
        ...action.realtorData,
        httpStatus: StatusCodes.OK,
        isLoading: false,
      };
    case actionTypes.FETCH_FAILED:
      return {
        httpStatus: action.httpStatus,
        isLoading: false,
      };
    default:
      return state;
  }
};
